import { defineStore } from 'pinia';

export const useProductStore = defineStore({
  id: 'product',
  state: () => ({
    isLoading: false,
    currentProduct: null,
    currentProductData: null,
    groupedExtras: null,
    quantity: 0,
    variants: null,
    selectedAttributes: [],
    selectedExtras: [],
    extras: [],
    basketSummary: {
      subtotal: "",
      basketCount: 0,
      tax: "",
      total: ""
    },
    basketUrl : '/basket/'
  }),
  getters: {
    getCurrrentProduct(state) {
      return state.currentProduct;
    },
    getBasketCount(state) {
      return state.basketSummary.basketCount;
    },
    getBasketSummary(state) {
      return state.basketSummary;
    },
  },
  actions: {
    async fetchBasketCount() {
      try {
        const response = await fetch(process.env.API_URL + '/basket/BasketCount', {
            method: 'GET'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        this.basketSummary.basketCount = data;
      } 
      catch (error) {
          console.error('There was a problem fetching the data:', error);
      }
    },
    updateIsLoading(isLoading) {
      this.isLoading = isLoading;
    },
    updateCurrentProduct(product) {
      this.currentProduct = product;
    },
    updateCurrentProductData(productData) {
      this.currentProductData = productData;
    },
    updateExtras(extras) {
      this.extras = extras;
    },
    updateBasketUrl(url) {
      this.basketUrl = url;
    },
    updateGroupedExtras(groupedExtras) {
      this.groupedExtras = groupedExtras;
    },
    updateQuantity(quantity) {
      this.quantity = quantity;
    },
    updateVariants(variants) {
      this.variants = variants;
    },
    updateSelectedAttributes(attributeAliases) {
      this.selectedAttributes = [ ...attributeAliases ];
    },
    updateSelectedExtras(extraAliases) {
      this.selectedExtras = [ ...extraAliases ];
    },
    updateSelectedAttributeAtIndex(index, value) {
      this.selectedAttributes.splice(index, 1, value);
    },
    updateSelectedExtraAtIndex(index, value) {
      this.selectedExtras.splice(index, 1, value);
    },
  },
});